module.exports = require("@tiptap/extension-horizontal-rule");